import { Link, TextField } from '@material-ui/core';
import React, { useEffect, useState } from 'react';

import { ModelSecondaryButton } from '~/src/dash/components/model-secondary-button';
import {
  IMonitorNotificationProviderBaseClass,
  IMonitorNotificationProviderBaseClassProps,
} from '~/src/dash/components/monitor/monitor_notifications/notifier';
import { DEMO_ACCOUNTS } from '~/src/dash/globals/constants';
import { IStore } from '~/src/dash/reducers/store';
import { IUserStateProps } from '~/src/dash/types/props';
import { decorate } from '~/src/dash/utils/decorator';
import { ct } from '~/src/dash/publicaUI';

export interface IMonitorNotifierSlackData {
  webhook: string;
}

export interface IMonitorNotifierSlackDataForHistory {
  webhook: string;
}

interface IProps extends IMonitorNotificationProviderBaseClassProps, IUserStateProps {}

function _MonitorNotifierURLComponent(props: IProps) {
  const data = (props.notifier.Data as IMonitorNotifierSlackData) || {};

  const [webhook, setWebhook] = useState(data.webhook || '');

  useEffect(() => {
    props.onUpdateData(createData());
  }, [webhook]);

  const createData = function (): IMonitorNotifierSlackData {
    // build data
    return {
      webhook,
    };
  };

  return (
    <>
      <Link target='_blank' href='https://api.slack.com/messaging/webhooks'>
        <ModelSecondaryButton>How to create a slack webhook</ModelSecondaryButton>
      </Link>
      <TextField
        id='notifier-slack-webhook'
        label='Slack webhook'
        variant='standard'
        onChange={({ target }: React.ChangeEvent<HTMLInputElement>) => {
          setWebhook(target.value);
        }}
        value={DEMO_ACCOUNTS.includes(props.user.user.Username) ? 'webhook.slack.com' : webhook}
        fullWidth
      />
    </>
  );
}

export const MonitorNotifierURLComponent = decorate(
  {
    redux: (state: IStore) => {
      return {
        user: state.user,
        session: state.session,
      };
    },
    router: true,
  },
  _MonitorNotifierURLComponent,
);

export class MonitorNotifierSlack implements IMonitorNotificationProviderBaseClass {
  returnData: (data: any) => void = undefined as any;

  Render = (notifier: any) => (
    <MonitorNotifierURLComponent
      notifier={notifier}
      onUpdateData={(data: any) => {
        if (this.returnData !== undefined) {
          this.returnData(data);
        }
      }}
    />
  );

  SetReturnData(cb: (data: any) => void) {
    this.returnData = cb;
  }

  Validate(notifier: any): string {
    if (notifier === undefined) {
      return ct('ErrorInvalidNotification');
    }
    const data = (notifier.Data as IMonitorNotifierSlackData) || {};
    if (data.webhook === undefined || data.webhook === '') {
      return ct('ErrorItemCannotBeEmpty', { item: ct('Webhook') });
    }

    // Validate that webhook contains the required Slack domain
    if (!data.webhook.includes('https://hooks.slack.com')) {
      return ct('ErrorInvalidSlackWebhook');
    }

    return '';
  }

  IsSuperAdminOnly(): boolean {
    return false;
  }
}
